export default "__VITE_ASSET__C_OhIYmJ__"